import script from "./SimpleLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./SimpleLayout.vue?vue&type=script&setup=true&lang=ts"

import "./SimpleLayout.vue?vue&type=style&index=0&id=545548c6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-545548c6"]])

export default __exports__